import { useState, useRef } from "react";
import useSessionStore from "store/sessionStore";
import { button, link, pageview } from "@qoohoo/common/constants/analytics";
import useScrollHeight from "@qoohoo/common/hooks/useScrollHeight";
import * as Track from "@qoohoo/common/utils/analytics/track";
import * as Posthog from "@qoohoo/common/utils/analytics/posthog";
import UserAvatar from "@qoohoo/common/components/UserAvatar";

const Creator = ({ channelDetails }) => {
  const userData = useSessionStore((state) => state.userData);
  const descRef = useRef(<div></div>);
  const isVisible = useScrollHeight(descRef);
  const [showMore, setShowMore] = useState(false);
  const userNameOrFullname =
    channelDetails.creator.fullname || channelDetails.creator.username;
  const isVerifiedCreator = channelDetails.creator.is_verified_creator;
  const trackDetails = {
    current_screen: pageview.channel_details,
    url: `/by/${channelDetails.creator.username}`,
    uid: channelDetails.uid,
    name: channelDetails.name,
    "creator.uid": channelDetails.creator.uid,
    "creator.full_name": channelDetails.creator.fullname,
    "creator.username": channelDetails.creator.username,
    is_verified_creator: isVerifiedCreator,
  };

  function trackCreatorProfileLinkClick() {
    const data = {
      user_uid: userData?.uid,
      entity_uid: channelDetails?.uid,
      entity_type: channelDetails?.type,
      creator_uid: channelDetails?.creator?.uid,
      entity_name: channelDetails?.name,
      total_amount:
        channelDetails?.plans?.[0]?.amount_after_discount ??
        channelDetails?.plans?.[0]?.amount,
      currency: channelDetails?.currency,
      subscription_plan_interval: channelDetails?.plans?.[0]?.interval,
      subscription_plan_duration: channelDetails?.plans?.[0]?.duration,
      platform: "web",
    };

    console.log("Posthog button click data", data);
    Posthog.pageView("creator_profile_btn", data);
    Track.linkClick(link.creator_profile_link, trackDetails);
  }

  return (
    <div className="mt-4 pt-8 sm:pt-10 md:pt-12">
      <div className="h-[72px] w-[72px] sm:w-24 sm:h-24 rounded-full bg-[#22272B] overflow-hidden text-2xl md:text-4xl font-bold flex items-center justify-center">
        <a
          target="_blank"
          href={`/by/${channelDetails.creator.username}`}
          onClick={trackCreatorProfileLinkClick}
        >
          <UserAvatar
            avatarUrl={channelDetails.creator.avatar?.url}
            userName={userNameOrFullname}
            alt={userNameOrFullname}
          />
        </a>
      </div>
      <a
        target="_blank"
        href={`/by/${channelDetails.creator.username}`}
        onClick={trackCreatorProfileLinkClick}
        className="inline-block mt-5 sm:mt-8"
      >
        <div className="flex justify-start items-center">
          <h2 className="text-xl font-medium sm:text-2xl font-inter truncate">
            {channelDetails.creator.fullname || channelDetails.creator.username}
          </h2>
          {isVerifiedCreator && (
            <img
              src="/assets/icons/round-verified.svg"
              alt="verified"
              className="w-5 h-5 ml-2 lg:w-6 lg:h-6"
            />
          )}
        </div>
      </a>
      <p
        ref={descRef}
        className={`text-[#F0F0F0] mt-3 sm:mt-4 text-sm sm:text-base whitespace-pre-wrap font-inter ${
          showMore ? "line-clamp-none" : "line-clamp-6"
        }`}
      >
        {channelDetails.creator.bio}
      </p>
      {isVisible && (
        <button
          className="mt-2 font-semibold font-nunito hover:opacity-90"
          onClick={() => {
            Track.buttonClick(button.description_show_more, {
              ...trackDetails,
              type: "creator_bio",
            });
            setShowMore(!showMore);
          }}
        >
          {showMore ? "show less" : "show more"}
        </button>
      )}
    </div>
  );
};

export default Creator;
